import React from 'react';
import { googlePlayLink } from 'utils/useGotoAppInstall';
import { GooglePlay } from 'components/Icons/Stores';

export default props => {
    return <a href={googlePlayLink('https')} title='Google Play' {...props}><GooglePlay /></a>
}